export default "__VITE_ASSET__Hz3ulCM2__"